import { Fragment, useEffect, useState } from 'react';
import styles from './styles.scss';
import { Button, BUTTON } from 'components/common/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import classnames from 'classnames';

export default function Footer({ isEditing, setIsEditing, hideDeleteButton, isDeleting, setIsDeleting, isCreating, onCancel, onSubmit, onDelete, onSaveEdit, handleConfirmDelete, disableSave }) {
    const cancelFromDeleteScreen = () => {
        setIsDeleting(false);
        setIsEditing(true);
    };
    const [isCreatingNew, setIsCreatingNew] = useState(isCreating);
    useEffect(() => {
        if (isEditing) {
            setIsDeleting(false);
            setIsCreatingNew(false);
        }
    }, [isEditing]);
    return (
        <div className={`${isDeleting ? styles.Footer + ' ' + styles.Footer_Deleting : styles.Footer}`}>
            <Fragment>
                {
                    isEditing && (
                        <Fragment>
                            <Button
                                bgcolor={BUTTON.BGCOLOR.CLEAR}
                                type={BUTTON.SIZE.SECONDARY}
                                onClick={onDelete}
                                style={{ visibility: `${hideDeleteButton ? 'hidden' : 'visible'}` }}
                                className={classnames(styles.Footer_Delete_Bootom, styles.Button_Padding)}
                            >
                                <FontAwesomeIcon icon={faTrashAlt} className={styles.Footer_Trash_Icon} />
                                <p className={styles.Footer_Red_Text_Color}>Delete Record</p>
                            </Button>
                            <div className={styles.Footer_edit_section}>
                                <Button
                                    bgcolor={BUTTON.BGCOLOR.WHITE}
                                    color={BUTTON.COLOR.BLACK}
                                    outline={BUTTON.OUTCOLOR.LIGHTGREY}
                                    onClick={onCancel}
                                    className={classnames(styles.Footer_Button_Font, styles.Button_Padding)}
                                >
                                    Cancel
                                </Button>

                                <Button
                                    type={BUTTON.SIZE.SECONDARY}
                                    bgcolor={BUTTON.BGCOLOR.ORANGE}
                                    color={BUTTON.COLOR.WHITE}
                                    onClick={onSaveEdit}
                                    disabled={disableSave}
                                    className={classnames(styles.Footer_Button_Font, styles.Button_Padding)}
                                >
                                    Save
                                </Button>
                            </div>
                        </Fragment>
                    )
                }

                {
                    isDeleting && (
                        <Fragment>
                            <div className={styles.Footer_delete_section}>
                                <Button
                                    type={BUTTON.SIZE.SECONDARY}
                                    bgcolor={BUTTON.BGCOLOR.CLEAR}
                                    color={BUTTON.COLOR.BLACK}
                                    outline={BUTTON.OUTCOLOR.LIGHTGREY}
                                    onClick={cancelFromDeleteScreen}
                                    className={classnames(styles.Footer_Cancel_Bottom_button, styles.Footer_Button_Font, styles.Button_Padding)}
                                >
                                    Cancel
                                </Button>

                                <Button
                                    type={BUTTON.SIZE.SECONDARY}
                                    onClick={handleConfirmDelete}
                                    className={classnames(styles.Footer_Delete_Bottom_Confirm, styles.Footer_Button_Font, styles.Button_Padding)}
                                >
                                    <p className={styles.Footer_White_Text_Color}>Delete Record</p>
                                </Button>
                            </div>
                        </Fragment>
                    )
                }

                {
                    isCreatingNew && (
                        <Fragment>
                            <Button
                                bgcolor={BUTTON.BGCOLOR.CLEAR}
                                color={BUTTON.COLOR.BLACK}
                                outline={BUTTON.OUTCOLOR.LIGHTGREY}
                                onClick={onCancel}
                                className={classnames(styles.Footer_Button_Font, styles.Button_Padding)}
                            >
                                Cancel
                            </Button>
                            <Button
                                type={BUTTON.SIZE.SECONDARY}
                                bgcolor={BUTTON.BGCOLOR.ORANGE}
                                color={BUTTON.COLOR.WHITE}
                                onClick={onSubmit}
                                className={classnames(styles.Footer_Button_Font, styles.Button_Padding)}
                            >
                                Add Delegation
                            </Button>
                        </Fragment>
                    )
                }
            </Fragment>
        </div>
    );
}
